import { useTranslation } from "react-i18next";
import { UtilityAdminKey } from "../i18n/utility-admin-keys";

export type UtilityAdminTFunction = (key: UtilityAdminKey, options?: Record<string, unknown>) => string;

/**
 * `useTranslation("utilityAdmin")` with the keys checked against the generated
 * `UtilityAdminKey` union. i18next itself sees the namespace as untyped (typing it the way
 * `customer` and `bpsAdmin` are typed blows the CRA type-check worker's heap), so the
 * narrowing happens here, in one place, and every page keeps the compile-time check.
 */
export const useUtilityAdminTranslation = () => {
	const { t, i18n, ready } = useTranslation("utilityAdmin");

	return { t: t as unknown as UtilityAdminTFunction, i18n, ready };
};
